'use strict'

import { storageAvailable } from './util'; 

export default class Tracker {
    constructor() {
    }
    init() {
		window.staticEvents.addListener('trackPageView', (data) => {
			this.trackPageView(data);
		});
		window.staticEvents.addListener('trackAction', (data) => {
			const group = data[0];
			const action = data[1];
			const detail = data[2] ? data[2] : '';
			const number = data[3] ? data[3] : 0;
			this.trackAction(group, action, detail, number);
		});
		window.staticEvents.addListener('trackEvent', (data) => {
			const category = data[0];
			const action = data[1];
			const name = data[2];
			this.trackEvent(category, action, name);
		});
        this.bTrackDomstream = false;
        _paq.push(['enableHeartBeatTimer']);
        //accurately measure the time spent on the last pageview of a visit
        var visitor_id;
        _paq.push([ function() { visitor_id = this.getVisitorId(); }]);
        this.active = true;
        window.staticEvents.addListener('deactivateCookies', () => {
            this.disableCookies();
        });
        window.staticEvents.addListener('deactivateTracking', () => {
            this.disableTracking();
        });
        window.staticEvents.addListener('activateCookies', () => {
            this.enableCookies();
        });
        window.staticEvents.addListener('activateMatomo', () => {
            this.enableTracking();
        });
    }

    disableCookies() {
        this.trackEvent("bdsg","disable","cookies");
        _paq.push(['disableCookies']);
    }
    disableTracking() {
        this.trackEvent("bdsg","disable","tracking");
        _paq.push(['forgetConsentGiven']);
        _paq.push(['disableHeartBeatTimer']);
        this.active = false;
    }

    enableCookies() {
        this.trackEvent("bdsg","enable","cookies");
        _paq.push(['enableCookies']);
    }
    enableTracking() {
        this.trackEvent("bdsg","enable","tracking");
        _paq.push(['setConsentGiven']);
        _paq.push(['enableHeartBeatTimer']);
        this.active = false;
    }

        
    getVisitorId() {
        if (storageAvailable()) { 
            if(!localStorage.getItem('firstVisit')) {
                const now = Date.now();
                localStorage.setItem('firstVisit',now);
                return now; 
            } else {
                return localStorage.getItem('firstVisit');
            }
        } else {
            return Date.now();
        }
    }
    trackAction(group, action, detail, number) {
        //if (typeof OWATracker != 'undefined') {
            //this.trackDomstream();
            //OWATracker.trackAction(group, action, detail, number);
        //}
    }
    trackEvent(category, action, name) {
        if (this.active) {
            _paq.push(['trackEvent', category, action, name]);
        }
    }
    trackDomstream() {
        //if (!this.bTrackDomstream) {
            ////OWATracker = new OWATracker();
            //OWATracker.trackDomStream();
            //this.bTrackDomstream = true;
        //}
    }
    trackPageView(data) {
        //if (typeof OWATracker != 'undefined') {
            //OWATracker.setPageTitle(data);
            //OWATracker.setPageType('super-page');
            //OWATracker.trackPageView();
        //}
        if (this.active) {
            _paq.push(['setDocumentTitle', data]);
            _paq.push(['trackPageView']);
        }
    }
}
